<div class="m-2 p-2" style="overflow-y: scroll; max-height: 400px; border-radius: 10px">
  
  <!-- Error indicator for scroll functionality - positioned at top for scroll targeting -->
  <div *ngIf="gridQuestion && gridQuestion['IsValid'] === false" class="errormsg"></div>
  <!-- Main question level error message -->
  <div *ngIf="gridQuestion && gridQuestion.errorMessage && gridQuestion.isQuestionRequired === 'Y'" style="color: red; margin-bottom: 10px">
    {{gridQuestion.errorMessage}}
  </div>
  <!-- starting of  fixed-grid Start -->
  <div class="table-container" *ngIf="gridQuestion.subQuestions?.length" style="overflow-x: auto">
    <table style="
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        border: 1px solid #ddd;
        font-family: Arial, sans-serif;
        min-width: max-content;
      ">
      <thead style="background-color: #f4f4f4">
        <tr>
          <th *ngFor="let option of gridQuestion.options; let i = index"
            style="padding: 8px; border: 1px solid #ddd; font-weight: bold; text-align: center">
            <ng-container>
              <label style="font-weight: bold; text-align: center; display: block">
                {{ gridQuestion.options[i].value }}
              </label>
            </ng-container>
          </th>
          <th class="header" *ngIf="!IsReadOnly">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of gridQuestion.responses ; let rowIndex = index" style="background-color: #fff">
          <td *ngFor="let cell of row.questions; let colIndex = index"
            style="padding: 8px; border: 1px solid #ddd; position: relative">
            <ng-container>
              <ng-container>
                <!-- mutlipe choice question started-->
                <div class="gridResponse fixedWidth centerFlex" *ngIf="cell.inputType === 'mul'">
                  <app-inputType-mul [IsReadOnly]="IsReadOnly" [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false" [question]="cell" (childQuestion)="GetChildData($event, rowIndex)"
                    (conditionalChange)="isConditionalCheck($event)"
                    (inputChange)="InputChange($event)"></app-inputType-mul>
                </div>
                <!-- mutlipe choice question ended-->

                <!--combo box started-->
                <div class="fixedWidth centerFlex pr-3" *ngIf="cell.inputType === 'cmb'">
                  <app-inputType-dropdown [IsReadOnly]="IsReadOnly" [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false" [question]="cell" (childQuestion)="GetChildData($event, rowIndex)"
                    (conditionalChange)="isConditionalCheck($event)"
                    (inputChange)="InputChange($event)"></app-inputType-dropdown>
                </div>
                <!--combo box ended-->

                <!-- radio button section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'rdo'">
                  <ng-container
                    *ngTemplateOutlet="radioButtonTemplate; context: { question: cell, option: gridQuestion.options[colIndex].value,colIndex: colIndex, rowIndex: rowIndex, isReadOnly: IsReadOnly }"></ng-container>
                </div>
                <!-- radio button section ended -->

                <!-- checkbox section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'chk'">

                  <ng-container
                    *ngTemplateOutlet="checkboxTemplate; context: { question: cell, option: gridQuestion.options[colIndex].value, isReadOnly: IsReadOnly }"></ng-container>
                </div>
                <!-- checkbox section ended -->

                <!-- text box section started -->
                <div *ngIf="cell.inputType === 'txb' || cell.inputType === 'txa'"
                  [ngClass]="cell.inputType === 'txa' ? 'grid-textarea-cell' : 'fixedWidth centerFlex pr-5'">
                  <app-inputType-text [class.grid-textarea]="cell.inputType === 'txa'"
                    [IsReadOnly]="IsReadOnly" [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false" [question]="cell" (childQuestion)="GetChildData($event, rowIndex)"
                    (inputChange)="InputChange($event)"></app-inputType-text>
                </div>
                <!-- text box section ended -->

                <!-- date picker section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'dte'">
                  <app-inputType-date [IsReadOnly]="IsReadOnly" [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false" [question]="cell" (childQuestion)="GetChildData($event, rowIndex)"
                    (inputChange)="InputChange($event)"></app-inputType-date>
                </div>
                <!-- date picker section ended -->

                <!-- rating section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'rating'">
                  <app-inputType-rating [IsReadOnly]="IsReadOnly" [questionIndex]="rowIndex + '-' + colIndex"
                    [showName]="false" [question]="cell" (childQuestion)="GetChildData($event, rowIndex)"
                    (inputChange)="InputChange($event)"></app-inputType-rating>
                </div>
                <!-- rating section ended -->

                <!-- signature section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'sign'">
                  <app-inputType-sign [IsReadOnly]="IsReadOnly" [question]="cell" [showName]="false"
                    [questionIndex]="rowIndex + '-' + colIndex" (childQuestion)="GetChildData($event, rowIndex)"
                    (inputChange)="InputChange($event)"></app-inputType-sign>
                </div>
                <!-- signature section ended -->

                <!-- file upload section started -->
                <div class="fixedWidth centerFlex pr-5" *ngIf="cell.inputType === 'fileupload'">
                  <app-inputType-fileUpload [questionIndex]="rowIndex + '-' + colIndex" [IsReadOnly]="IsReadOnly"
                    [showName]="false" [question]="cell" (childQuestion)="GetChildData($event, rowIndex)"
                    (inputChange)="InputChange($event)"></app-inputType-fileUpload>
                </div>
                <!-- file upload section ended -->
              </ng-container>

              <ng-template #textAreaOrLabel>
                <ng-container *ngIf="
                    cell.inputType === 'txb' || cell.inputType === 'txa';
                    else labelOnly
                  ">
                  <textarea style="width: 100%"></textarea>
                </ng-container>
                <ng-template #labelOnly>
                  <label style="word-wrap: break-word; max-width: 100ch;">{{ cell.value }}</label>
                </ng-template>
              </ng-template>
            </ng-container>
          </td>
          <td *ngIf="!IsReadOnly">
            <button mat-icon-button color="warn" (click)="removeResponse(rowIndex)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!IsReadOnly" class="text-right mt-3">
    <button type="button" mat-raised-button color="primary" (click)="addNewResponse()">Add Row</button>
  </div>

  <!-- starting of  fixed-grid End -->
</div>


<!---Checkbox template started-->
<ng-template #checkboxTemplate let-question="question" let-option="option" let-isReadonly="isReadOnly">
  <div class="row p-2" style="display: flex;justify-content: space-between;">
    <div class="mat-body-1">
      <div *ngIf="gridQuestion.options.length > 0">
        <mat-checkbox [checked]="question.responseText === option" [disabled]="isReadonly"
          [ngClass]="{'readOnly':isReadonly}"
          (change)="question.responseText = $event.checked ? option : '';InputChange(true)">
        </mat-checkbox>
      </div>
      <div class="errormsg mat-body-1 margin-top" *ngIf="question.errorMessage && !question.responseText">
        {{question.errorMessage}}</div>
    </div>
  </div>
</ng-template>
<!--Checkbox templated ended-->


<!---- radio button template started-->
<ng-template #radioButtonTemplate let-question="question" let-option="option" let-rowIndex="rowIndex"
  let-colIndex="colIndex" let-isReadonly="isReadOnly">
  <div class="row p-2" style="display: flex;justify-content: space-between;">
    <div class="mat-body-1">
      <div *ngIf="gridQuestion.options.length > 0">
        <mat-radio-group [(ngModel)]="question.responseText">
          <mat-radio-button name="question.responseText" [checked]="question.responseText == option"
            [disabled]="isReadonly" [ngClass]="{'readOnly':isReadonly}" [value]="option" (change)="InputChange(true)">
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="errormsg mat-body-1 margin-top" *ngIf="question.errorMessage && !question.responseText">
        {{question.errorMessage}}</div>
    </div>
  </div>
</ng-template>
<!---- radio button template ended-->